import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import styles from "./LocationLabel.module.css";
import t from "../../../utils/translation";

const LocationLabel = ({ location }) => {
  const barcodeRef = useRef(null);
  const barcodeValue = `${location?.code}`;

  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, `${location?.code}`, {
        format: "CODE128",
        displayValue: false,
        fontSize: 12,
        height: 40,
        margin: 0,
      });
    }
  }, [barcodeValue]);

  return (
    <div className={styles.containerPrint}>
      <div className={styles.label}>
        <p className={styles.line}>{location?.locationName}</p>

        <hr className={styles.divider} />
      </div>
      <div className={styles.barcode}>
        <canvas ref={barcodeRef}></canvas>
        <p className={styles.barcodeText}>{`${location?.code}`}</p>
      </div>
      <p className={styles.line}>
        {t("ObservationSpan")}: {location?.observations}
      </p>
    </div>
  );
};

export default LocationLabel;
